<template>
  <div class="container">
    <div class="text-container">
      <img class="done-image" src="@/assets/done.png"/>
      <span class="info-text">{{$t('deliveryGoods.completeOrder')}}</span>
    </div>
    <el-button
      class="sure-button"
      size="small"
      @click="onSure">
      {{$t('common.sure')}}
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'completeOrder',
  methods: {
    onSure() {
      this.$emit('nexStep');
    },
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .text-container {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 50px;
  }
  .done-image {
    width: 40px;
    height: 40px;
  }
  .info-text {
    color: #404040;
    font-size: 24px;
    margin-left: 10px;
  }
  .sure-button {
    background: #EC7900;
    color: white;
    margin-top: 50px;
  }
</style>
